import { MagistralDrugTemplate, MagistralDrugTemplateCreateCommand } from '@dreryk/drerykweb-medicine-api';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Choice } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import {
   MagistralDrugTemplateFormBean,
   MagistralDrugTemplateFormController,
} from './form/MagistralDrugTemplateForm.types';
import { mapMedicineRawMaterialsTableBeanToMagistralDrugRawMaterials } from './modal/MagistralDrugTemplatesCommand.utils';

type MagistralDrugTemplatesCreateTemplateButtonProps = {
   readonly handleSubmit: MagistralDrugTemplateFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
};

const commandCreator = (parameters: MagistralDrugTemplateFormBean): MagistralDrugTemplateCreateCommand => {
   const command = new MagistralDrugTemplateCreateCommand();
   command.name = parameters.drugName!;
   command.additionalDetails = Choice.withUseDefaultIfNull(parameters.additionalDetails ?? null);
   command.form = parameters.drugForm!;
   command.magistralDrugMedicineRawMaterials = mapMedicineRawMaterialsTableBeanToMagistralDrugRawMaterials(
      parameters.medicineRawMaterials
   );
   return command;
};

export const MagistralDrugTemplatesCreateTemplateButton = (
   props: MagistralDrugTemplatesCreateTemplateButtonProps
): JSX.Element => {
   return (
      <FormsTemplates.SendTemplateButton<MagistralDrugTemplateFormBean, MagistralDrugTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={commandCreator}
         onSuccess={props.onSuccess}
      />
   );
};
